import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import TextBox from "../controls/form/TextBox";
import User from "../../services/user";
import PubSub from "../../services/PubSub";

const UserSettings = ({ id, show, onCancel }) => {
    const [userDetails, setUserDetails] = useState({});

    const [translate] = useTranslation();

    const getUser = useCallback(async () => {
        const response = await User.getUser();
        if(!response.error) {
            setUserDetails({ ...response.data });
        }
    }, []);

    const updateUser = useCallback(async ({ firstName, lastName }) => {
        const updatedObj = {
            firstName,
            lastName
        }
       
        const response = await User.updateUser(id, updatedObj);
        if(!response.error) {
            PubSub.publish("refresh-user-details");
            onCancel();
        }
    }, [id, onCancel]);

    useEffect(() => {
        if(id && show) {
            getUser(id);
        }
    }, [id, show, getUser]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik initialValues={{
                firstName: userDetails.firstName || "",
                lastName: userDetails.lastName || "",
                email: userDetails.email || ""
            }} 
            onSubmit={updateUser} enableReinitialize>
                <Form>
                    <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_USER_DETAILS")}</BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <TextBox label={translate("OTM_FIRST_NAME")} type="text" name="firstName" />
                        <TextBox label={translate("OTM_LAST_NAME")} type="text" name="lastName" css="mt-3" />
                        <TextBox label={translate("OTM_EMAIL")} type="email" name="email" disabled css="mt-3" />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" className="btn-sm">{translate("OTM_SAVE")}</Button>
                        <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default UserSettings;